import React, { FC, useContext } from 'react'
import { PageLayout, Spinner } from '../System'
import { StyledCheckoutView, PromoCodeInput } from '.'
import { Cart } from '../Cart'
import useCart from '../../redux/shopping-cart/useCart'
import { FormMessage } from '../System/Form'
import { EmptyState } from '../EmptyState'
import { userStore } from '../utils/UserContext'
import { CourseOnlyCheckout } from './CourseOnlyCheckout'

const CheckoutView: FC = () => {
  const {
    cartItems,
    total,
    paymentError,
    discount,
    paymentLoading,
    actions: {
      processPayment, setDiscount, setDiscountCode, removeFromCart
    }
  } = useCart()
  const { user, loaded } = useContext(userStore)

  // Pushes to course only checkout if a trial user
  if (loaded && (user?.trial || user?.stripeSubscriptionStatus === 'Inactive')) {
    return <CourseOnlyCheckout />
  }

  return (
    <PageLayout maxWidth={1200} pageTitle="Checkout">
      <StyledCheckoutView isEmpty={!cartItems.length}>
        <div className="checkout-sizer">
          <div className="checkout-left">
            {paymentError && <FormMessage message={paymentError} type="error" />}

            <div className="cart-area">
              {cartItems.length > 0 && (
                <Cart items={cartItems} discount={discount} removeFromCart={removeFromCart} />
              )}
              {cartItems.length === 0 && (
                <EmptyState
                  title="Your cart is empty."
                  suggestion="Add a course to your cart to check out."
                  height={300}
                />
              )}
            </div>
          </div>

          <div className="checkout-summary-container">
            <div className="checkout-summary-top">
              <div className="checkout-summary-heading">
                <span>Summary</span>
              </div>
              <ul className="checkout-summary">
                {!!discount && (
                  <li className="checkout-summary-item discount">
                    <span className="checkout-summary-item-label">Discount</span>
                    <span className="checkout-summary-item-amount">
                      <span>-${discount.toFixed(2)}</span>
                    </span>
                  </li>
                )}
                <li className="checkout-summary-item">
                  <span className="checkout-summary-item-label">Total ({cartItems.length})</span>
                  <span className="checkout-summary-item-amount">
                    <span>${total.toFixed(2)}</span>
                  </span>
                </li>
              </ul>
            </div>
            <div className="checkout-summary-bottom">
              <PromoCodeInput
                totalCost={total}
                onChange={(e) => {
                  const { discountAmount, stripeID } = e
                  setDiscount(discountAmount)
                  setDiscountCode(stripeID)
                }}
              />
              <button
                className="purchase-btn"
                onClick={() => processPayment()}
                disabled={paymentLoading || !cartItems.length}
              >
                {paymentLoading ? (
                  <Spinner size="small" />
                ) : (
                  `Purchase Item${cartItems.length === 1 ? '' : 's'} for $${total.toFixed(2)}`
                )}
              </button>
            </div>
          </div>
        </div>
      </StyledCheckoutView>
    </PageLayout>
  )
}

export default CheckoutView
